/**
 * Product back link + collection scroll return (KAN-29)
 *
 * Takes the visitor from a product page back to the collection they were browsing, at the position they left it.
 *
 * Restoring scroll is the browser's job, and it only does it for history traversals — going "back" by following a link
 * to the same URL is a fresh navigation and lands at the top. So there are two paths here:
 *
 *   1. The previous history entry really is a collection page (the normal collection -> product -> back journey). The
 *      link calls history.back() instead of following its href, and the browser restores the whole entry: scroll
 *      position, and any extra pages the visitor had loaded into the grid.
 *   2. There is no such entry — the visitor hopped product -> related product, or arrived straight from search. Then the
 *      last collection this session saw is used as the target, and this script restores the scroll position itself from
 *      what it recorded when the visitor left that page.
 *
 * The href in the markup is a real collection URL, so with JavaScript off, or for a crawler, the link still goes
 * somewhere sensible — it just lands at the top of the page.
 *
 * Loaded on collection pages as well as product pages, because the recording in (2) has to happen on the collection
 * page.
 */
(function () {
  if (window.themeProductBackLinkLoaded) return;
  window.themeProductBackLinkLoaded = true;

  var STORAGE_KEY = 'theme:collection-return';

  function readReturn() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function writeReturn(value) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (error) {
      /* Private mode or a full quota — the link falls back to its server-rendered href. */
    }
  }

  /* A collection URL on this storefront: /collections/<handle>, with or without filter and page parameters. */
  function collectionUrl(value) {
    if (!value) return null;

    var url;

    try {
      url = new URL(value, window.location.origin);
    } catch (error) {
      return null;
    }

    if (url.origin !== window.location.origin) return null;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+\/?$/i.test(url.pathname)) return null;

    return url.href;
  }

  function isHistoryTraversal() {
    try {
      var entry = window.performance.getEntriesByType('navigation')[0];
      return !!entry && entry.type === 'back_forward';
    } catch (error) {
      return false;
    }
  }

  /* ---- collection page: remember where the visitor was, and put them back when they return ---- */

  function initCollectionPage() {
    var here = collectionUrl(window.location.href);
    if (!here) return;

    // A traversal restores scroll on its own; stepping in would fight the browser and land in the wrong place.
    if (!isHistoryTraversal()) {
      var saved = readReturn();

      if (saved && saved.url === here && saved.scrollY > 0) {
        window.scrollTo(0, saved.scrollY);
      }
    }

    // pagehide fires for ordinary navigations and for going into the back/forward cache, which covers every way out of
    // this page that can bring the visitor back to it.
    window.addEventListener('pagehide', function () {
      writeReturn({ url: here, scrollY: Math.round(window.scrollY) });
    });
  }

  /* ---- product page: point the link at the right collection, and prefer a traversal when there is one ---- */

  function initProductPage() {
    var link = document.querySelector('[data-product-back-link]');
    if (!link) return;

    var referrer = collectionUrl(document.referrer);

    if (referrer && window.history.length > 1) {
      link.setAttribute('href', referrer);
      link.addEventListener('click', function (event) {
        // Let modified clicks (new tab, download, middle click) behave like the plain link they still are.
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        window.history.back();
      });

      return;
    }

    var saved = readReturn();
    if (saved && saved.url) link.setAttribute('href', saved.url);
  }

  function init() {
    initCollectionPage();
    initProductPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
